import { render, staticRenderFns } from "./ConfirmationOrder.vue?vue&type=template&id=4d2667cb"
import script from "./ConfirmationOrder.vue?vue&type=script&lang=ts"
export * from "./ConfirmationOrder.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationOrder.vue?vue&type=style&index=0&id=4d2667cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports